var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDouble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.8,
    height: 16.802,
    viewBox: "0 0 14.8 14.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check_double") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00a0e9",
    d: "M14.6,5.052,13.451,3.907a.691.691,0,0,0-.98,0L5.548,10.83,2.328,7.607a.691.691,0,0,0-.98,0L.2,8.755a.694.694,0,0,0,0,.983L5.057,14.6a.691.691,0,0,0,.98,0l8.556-8.562A.7.7,0,0,0,14.6,5.052ZM5.221,8.116a.459.459,0,0,0,.653,0L11.887,2.1a.464.464,0,0,0,0-.653L10.581.135a.459.459,0,0,0-.653,0L5.548,4.514l-1.6-1.6a.459.459,0,0,0-.653,0L1.984,4.219a.464.464,0,0,0,0,.653Z",
    transform: "translate(0.004 0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDouble);
export default __webpack_public_path__ + "static/media/check_double.68ea2eb41875e05b47d574b9b6e751b6.svg";
export { ForwardRef as ReactComponent };